export class Password{
	constructor(
        public previousPassword: string,
		public proposedPassword: string,
		public accessToken: string
	){}
}